import {Calendar} from 'lucide-react';
import {useAuth} from "@/provider/AuthProvider";
import {myAcademy} from "@/lib/services/academyService";
import WelcomeDashboardBox from "@/components/welcomeDashboard/WelcomeDashboardBox";

export default function WelcomeSection() {
    return <WelcomeDashboardBox mode={'teacher'} />
}
